import { Controller } from '@hotwired/stimulus'

// Intersection Observation Controller
//
// Toggles the visibility of a link element based on the intersection state
// of an observed element. When less than the specified ratio of the observed
// element is visible, the link element will be shown.
export default class extends Controller {
  static targets = ['link', 'observedElement']
  static classes = ['hidden', 'visible']
  static values = {
    ratio: Number
  }

  connect () {
    if (!this.hasObservedElementTarget) { return }

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        threshold: this.ratioValue
      }
    )

    this.observer.observe(this.observedElementTarget)
  }

  disconnect () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  isAboveViewport (entry) {
    return entry.boundingClientRect.top < 0
  }

  isVisibleEnough (entry) {
    return entry.intersectionRatio >= this.ratioValue
  }

  handleIntersection (entries) {
    this.linkTargets.forEach(link => {
      if (link.classList.contains(this.visibleClass)) { return }

      entries.forEach(entry => {
        if (this.isVisibleEnough(entry)) {
          link.classList.add(this.hiddenClass)
        } else if (!this.isAboveViewport(entry)) {
          link.classList.remove(this.hiddenClass)
        }
      })
    })
  }

  scrollToObservedElement () {
    if (!this.hasObservedElementTarget) { return }

    this.observedElementTarget.scrollIntoView({ behavior: 'smooth' });
  }
}
